import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Container = Phaser.GameObjects.Container;
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import PlayerStore from "@/store/player";
import {NewsPanel} from "@/scenes.ui/news-panel";
import {Tr} from "@/i18n/i18n";

export class ChestDescPanel extends Container {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement) {
        super(scene);

        this.height = 150;

        let mainText = TextUtils.addTextByFamily(scene, Tr('cht'),
            0, 30, '#ffc536', 15, 'normal', 600, Fonts.BENGALY_NORMAL);

        let comment = TextUtils.addTextByFamily(scene, Tr('chd'),
            0, 130, '#cbcbcb', 11, 'normal', 600, Fonts.BENGALY_NORMAL);

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.addChest(scene, canvas, -241, 80, Keys.CHEST_SILVER_CLOSED, 'silverChest2');
        this.addChest(scene, canvas, -144, 80, Keys.CHEST_AZURE_CLOSED, 'azureChest2');
        this.addChest(scene, canvas, -47, 80, Keys.CHEST_AMBER_CLOSED, 'amberChest2');
        this.addChest(scene, canvas, 47, 80, Keys.CHEST_GOLDEN_CLOSED, 'goldenChest2');
        this.addChest(scene, canvas, 144, 80, Keys.CHEST_JADE_CLOSED, 'jadeChest2');
        this.addChest(scene, canvas, 241, 80, Keys.CHEST_LAVA_CLOSED, 'lavaChest2');

        this.add([mainText, separator, comment]);
    }

    private addChest(scene: Phaser.Scene, canvas: HTMLCanvasElement, x: number, y: number, key: string, manualId: string) {
        let chest = SpriteUtils.scale(SpriteUtils.addSprite(scene, x, y, key), 0.35);
        chest.setInteractive().on('pointerup', () => {
            PlayerStore.getManual(manualId).then(man => {
                let stringsInManual = man.split('\n').length - 1;
                let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('manual'), man, () => {
                    ip.close();
                }, false, false);
                ip.openAnimated();
            });
        });
        this.add(chest);
    }

}
